__turbopack_context__.v({
  "iframe": "styles-module__LAkU4q__iframe",
});
